import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { type SignedUrl } from "@/lib/backend/api";

export const FILE_CUSTOM_FIELD_QUERY_KEY = "file-custom-field" as const;

/**
 * Fetch signed URL for custom field file
 *
 * @param userId - The user ID
 * @param definitionId - The custom field definition ID
 * @param filename - The filename
 * @returns Query options for TanStack Query
 */
export const queryOptions_custom_field_file_url = (
  userId: string,
  definitionId: string,
  filename: string,
) =>
  queryOptions({
    queryKey: [FILE_CUSTOM_FIELD_QUERY_KEY, "user", userId, definitionId, filename] as const,
    queryFn: async (): Promise<SignedUrl> => {
      // Use the existing getUserUrl endpoint from the API client
      // The key is the path in DigitalOcean Spaces: custom-fields/{definitionId}/{filename}
      const key = `custom-fields/${definitionId}/${filename}`;
      const response = await api.file.getUserUrl(userId, key);
      return response.data;
    },
    staleTime: 1000 * 60 * 50, // 50 minutes (signed URLs expire after 1 hour)
    placeholderData: keepPreviousData,
  });
